import { useHotkeys } from 'react-hotkeys-hook';
import { useFeatureFlag } from './useFeatureFlag';
import { FEATURE_FLAGS } from '@/common/domain/constants/featureFlags';

type FormTag = 'input' | 'select' | 'textarea';

export const useShiftDHotkey = (callback: () => void, isEnabled = true, enableOnFormTags: boolean | readonly FormTag[] = true) => {
  const areHotkeysEnabled = useFeatureFlag(FEATURE_FLAGS.ENABLE_HOTKEYS);
  useHotkeys('shift+d', callback, {
    enableOnFormTags: enableOnFormTags,
    enabled: areHotkeysEnabled && isEnabled
  });
};
